const fillable = [
  "ST8CRIC",
  "WIN247",
  "ZF549B",
  "OLBINT",
  "JITO",
  "DAAG",
  "ZF737",
  "TOP11",
  "FUNO",
  "HOT",
  "GPG",
  "DSTPLAY",
  "TEAM126",
  "GS365",
  "BBIN",
  "ZF752",
  "NS",
  "ZF1298",
  "HUIDU",
  "SKYWIN",
  "JCMMWEB",
  "BETJILIHD",
  "NAMASTE",
  "E2BETMSHD",
  "DBT247",
  "ZF985",
  "BET777",
  "OZWIN365",
  "BG777",
  "ZFCRIC",
  "NOVA88EXCH",
  "MX9BET",
  "LAXMI",
  "ALPHA",
  "TEKKABUZZMSHD",
  "STABET",
  "WCT9",
  "UNLPBT",
  "MOMO",
  "BDT9W",
  "UNLROM",
  "DL",
  "BDTPRO",
  "RDP",
  "KZCRIC"
]

export default fillable
